import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade show d-block",
  "data-bs-backdrop": "static",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop fade show" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (this.getActiveAnnouncement)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t('announcements.' + this.getActiveAnnouncement.code + '.title')), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.close && this.close(...args)))
                })
              ]),
              _createElementVNode("div", {
                class: "modal-body",
                innerHTML: _ctx.$t('announcements.' + this.getActiveAnnouncement.code + '.body')
              }, null, 8, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-primary",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (this.close && this.close(...args)))
                }, _toDisplayString(_ctx.$t('close')), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (this.doNotShowAgain && this.doNotShowAgain(...args)))
                }, _toDisplayString(_ctx.$t('doNotShowAgain')), 1)
              ])
            ])
          ])
        ]),
        _hoisted_8
      ], 64))
    : _createCommentVNode("", true)
}